import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import ResizeDetector from "react-resize-detector";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import useLogin from "hooks/useLogin";
import HeaderTitlePage from "layout/AppMain/HeaderTitlePage";
import AppHeader from "layout/AppHeader";
import AppSidebar from "layout/AppSidebar";
import AppFooter from "layout/AppFooter";

const AdminTemplate = (props) => {
  const { t } = useTranslation();
  let {
    colorScheme,
    enableFixedHeader,
    enableFixedSidebar,
    enableFixedFooter,
    enableClosedSidebar,
    closedSmallerSidebar,
    enableMobileMenu,
    enablePageTabsAlt,
  } = props;
  const history = useHistory();

  const { isLogged } = useLogin();

  /**
   *useEffect hook that redirects the user to the home page if they are not logged in.
   *@param {boolean} isLogged - a boolean value indicating if the user is logged in
   *@param {object} history - the history object provided by React Router for programmatic navigation
   */
  useEffect(() => {
    if (!isLogged) {
      history.push("/");
    }
  }, [isLogged, history]);

  return (
    <ResizeDetector
      handleWidth
      render={({ width }) => (
        <Fragment>
          <div
            className={cx(
              "app-container app-theme-" + colorScheme,
              { "fixed-header": enableFixedHeader },
              { "fixed-sidebar": enableFixedSidebar || width < 1250 },
              { "fixed-footer": enableFixedFooter },
              {
                "closed-sidebar": enableClosedSidebar || width < 1250,
              },
              {
                "closed-sidebar-mobile": closedSmallerSidebar || width < 1250,
              },
              { "sidebar-mobile-open": enableMobileMenu },
              { "body-tabs-shadow-btn": enablePageTabsAlt }
            )}
          >
            <AppHeader />
            <div className="app-main">
              <AppSidebar />
              <div className="app-main__outer">
                <div className="app-main__inner">
                  <CSSTransitionGroup
                    component="div"
                    transitionName="TabsAnimation"
                    transitionAppear={true}
                    transitionAppearTimeout={0}
                    transitionEnter={false}
                    transitionLeave={false}
                  >
                    <HeaderTitlePage
                      heading={t(props.heading)}
                      subheading={t(props.subheading)}
                      icon={`pe-7s-${props.icon} text-blue`}
                    />
                    {props.children}
                  </CSSTransitionGroup>
                </div>
                <AppFooter />
              </div>
            </div>
          </div>
        </Fragment>
      )}
    />
  );
};

const mapStateToProp = (state) => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,
});

AdminTemplate.propTypes = {
  children: PropTypes.any.isRequired,
  heading: PropTypes.any.isRequired,
  subheading: PropTypes.any,
  icon: PropTypes.any.isRequired,
  colorScheme: PropTypes.any.isRequired,
  enableFixedHeader: PropTypes.any.isRequired,
  enableFixedSidebar: PropTypes.any.isRequired,
  enableFixedFooter: PropTypes.any.isRequired,
  enableMobileMenu: PropTypes.any,
  enablePageTabsAlt: PropTypes.any.isRequired,
  enableClosedSidebar: PropTypes.any.isRequired,
  closedSmallerSidebar: PropTypes.any,
};

export default withRouter(connect(mapStateToProp)(AdminTemplate));
